import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button from 'src/components/design-system/Button';
import useConfirm from 'src/hooks/useConfirm';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import { calculateTotals } from '../useGlDistributionsGrandTotals';

const GlCodeAction: FC<GridCellProps> = (props) => {
  const { dataItem } = props;
  const { confirm } = useConfirm();
  const setInvoiceGlCodes = useContextSelector(InvoiceContext, (value) => value.setInvoiceGlCodes);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const setIsGlCodesDirty = useContextSelector(InvoiceContext, (value) => value.setIsGlCodesDirty);

  const handleDelete = useCallback(async () => {
    const isDeleteAccepted = await confirm({
      title: 'Delete GL Summary item',
      content: 'Are you sure you want to delete this GL Summary item ?',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      cancelColor: 'info',
    });
    if (isDeleteAccepted) {
      setIsGlCodesDirty(true);
      setInvoiceGlCodes((prev) => {
        const newCodes = [...prev].slice(0, -1).filter((item) => item.rowId !== dataItem.rowId);
        return [...newCodes, calculateTotals(newCodes)];
      });
    }
  }, [confirm, dataItem.rowId, setInvoiceGlCodes, setIsGlCodesDirty]);

  return (
    <GridCellBase {...props}>
      {dataItem?.isNewlyAdded && !isInvoiceEditDisabled && (
        <Button color="error" onClick={handleDelete} size="sm">
          Delete
        </Button>
      )}
    </GridCellBase>
  );
};

export default GlCodeAction;
